import { QuickFilter } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import { QF, getFilters, InitialFilters, OverrideFilter } from './helper';

type Args<T = void> = {
    quickFilters: QF<T>[];
    initialFilters?: InitialFilters<T>[];
    qfOverrides?: OverrideFilter<T>[];
};

// returns an object with
// the filters wanted for the table and the default initial filters to pass to the table
function useGetRuleQuickFilters<T = never>({ quickFilters, initialFilters, qfOverrides = [] }: Args<NoInfer<T>>) {
    const { t } = useTranslation();
    const filters = getFilters(t, qfOverrides);
    const actualFilters = filters.filter((v) => quickFilters.includes(v.id as never));
    // rearrange to match the index passed by the user.
    const visibleFilters = actualFilters.reduce((acc, curr) => {
        const foundIndex = quickFilters.findIndex((o) => o === curr.id);
        if (foundIndex !== -1) acc[foundIndex] = curr;
        return acc;
    }, [] as OverrideFilter<T>[]);

    const initialQuickFiltersToReturn = initialFilters?.reduce((acc, curr) => {
        // if current.id is not in initialFilters, early return
        const found = visibleFilters.find((v) => v.id === curr.id);
        if (!found) return acc;
        // if there is an item with an active id, include only the data that has the
        // specified activeIds
        acc.push({
            // it's a string lol
            id: found.id as string,
            // necessary for TS to be happy
            data: found.data.filter((v) => curr.activeId?.includes(v.id as never))
        });
        return acc;
    }, [] as { id: string; data: QuickFilter[] }[]);

    return {
        filters: visibleFilters,
        initialQuickFilters: initialQuickFiltersToReturn
    };
}

export default useGetRuleQuickFilters;
